
import { getFromDTonomyAPI, extractIP } from "../helpers/common";
import { getHeadersAsync } from "../helpers/mailbox";

export async function getReceivedFromGeoLocationsAsync(){
    const headers = await getHeadersAsync();
    const receivedHeaders = headers["Received"];
    const receivedFromIPs = [];

    if(!receivedHeaders){
        return [];
    }

    if(Array.isArray(receivedHeaders)){
        // Reverse to get starting ip to ending ip
        for(const i in receivedHeaders.reverse()){
            const receivedFromIP = getReceivedFromIP(receivedHeaders[i]);
            if(receivedFromIP){
                receivedFromIPs.push(receivedFromIP);
            }
        }
        
    }
    else{
        const receivedFromIP = getReceivedFromIP(receivedHeaders);
        if(receivedFromIP){
        receivedFromIPs.push(receivedFromIP);
        }
    }

    const geoLocations = await fetchIPGeolocationsAsync(receivedFromIPs);
    return geoLocations || [];
}

/**
 * API call to the DTonomy plugin backend service
 * Parses to JSON object if 200 response code returned
 * else we assume that the ip was invalid
 * @param {String} ip The ip address to submit to the geoip api.
 * @returns {Object}
 */
async function fetchIPGeolocationsAsync(ip){
    if(ip){
      let endpoint = "geoip/";
      console.log(ip);
      if(Array.isArray(ip)){
        endpoint += ip.join();
      }
      else{
        endpoint += ip;
      }
      const response = await getFromDTonomyAPI(endpoint);
      
      if(response.status == 200){
        const data = response.json();
        return data; 
      }
      else{
       // console.log("IPGeolocation Error Code for " + ip.join() + ": " + response.status + ": " + response.getContentText()); 
      }
    }
    else{
      console.log("The given ip parameter is undefined!")
    }
}
  
///**
// * Returns IP address of the "from" portion of the given "Received" header
// * @param {String} receivedHeader The text of the "Received" header
// * @returns {String}
// */
function getReceivedFromIP(receivedHeader){
    let receivedFrom = receivedHeader;
    const indexOfBy = receivedHeader.indexOf(" by ");
    if(receivedHeader && receivedHeader.startsWith("from") && indexOfBy != -1){
    // Get header substring of 'from' portion, until the 'by' portion (excluding 'by' portion)
    receivedFrom = receivedHeader.substring(0, indexOfBy);
    }
    
    const receivedFromIP = extractIP(receivedFrom);
    return receivedFromIP
}